"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      errorInfo: null,
      error: null
    };
    return _this;
  }

  (0, _createClass2["default"])(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      // Catch errors in any components below and re-render with error message, removed error and in state
      this.setState({
        errorInfo: errorInfo,
        error: error
      }); // eslint-disable-next-line no-console

      console.log('ERROR:', error, errorInfo);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          error = _this$state.error,
          errorInfo = _this$state.errorInfo;
      var _this$props = this.props,
          children = _this$props.children,
          customError = _this$props.customError,
          errorMessage = _this$props.errorMessage,
          showErrorDetails = _this$props.showErrorDetails;

      if (errorInfo || error) {
        var _errorInfo$componentS, _errorInfo$componentS2;

        // You can render any custom fallback UI
        return customError || /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h1", null, errorMessage), showErrorDetails && /*#__PURE__*/_react["default"].createElement("p", null, error.toString()), showErrorDetails && (errorInfo === null || errorInfo === void 0 ? void 0 : (_errorInfo$componentS = errorInfo.componentStack) === null || _errorInfo$componentS === void 0 ? void 0 : (_errorInfo$componentS2 = _errorInfo$componentS.split('\n')) === null || _errorInfo$componentS2 === void 0 ? void 0 : _errorInfo$componentS2.map(function (line) {
          return /*#__PURE__*/_react["default"].createElement("p", null, line);
        })));
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return {
        error: error
      };
    }
  }]);
  return ErrorBoundary;
}(_react.Component);

ErrorBoundary.defaultProps = {
  children: undefined,
  errorMessage: '',
  showErrorDetails: false,
  customError: null
};
ErrorBoundary.propTypes = {
  /** The normal children to render and catch errors from */
  children: _propTypes.node,

  /** A Error message to render on error */
  errorMessage: _propTypes.string,

  /** If true, render error message and call stack with message */
  showErrorDetails: _propTypes.bool,

  /** React node to render instead of error details or message */
  customError: _propTypes.node
};
ErrorBoundary.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ErrorBoundary",
  "props": {
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The normal children to render and catch errors from",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "errorMessage": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "A Error message to render on error",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "showErrorDetails": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, render error message and call stack with message",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "customError": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "React node to render instead of error details or message",
      "type": {
        "name": "node"
      },
      "required": false
    }
  }
};
var _default = ErrorBoundary;
exports["default"] = _default;